import { EventEmitter, Injectable, Output } from '@angular/core';
import { StateService } from '@uirouter/angular';

import { LANGUAGES } from './language.constants';
import { JhiLanguageService } from 'ng-jhipster';
import {
    TranslateService,
    TranslationChangeEvent,
    LangChangeEvent,
} from '@ngx-translate/core';

@Injectable()
export class JhiLanguageHelper {
    @Output()
    languageChange: EventEmitter<string> = new EventEmitter();

    constructor(
        private translateService: TranslateService,
        private $state: StateService,
        private languageService: JhiLanguageService
    ) {
        this.init();
    }

    init() {
        // FIXME onTranslationChange may not be required at all
        this.translateService.onTranslationChange.subscribe(
            (event: TranslationChangeEvent) => {
                this.updateTitle();
            }
        );
        this.translateService.onLangChange.subscribe(
            (event: LangChangeEvent) => {
                this.updateTitle();
            }
        );
    }

    getAll(): Promise<any> {
        return Promise.resolve(LANGUAGES);
    }

    getCurrentLang(): string {
        return this.translateService.currentLang;
    }

    /**
     * update the window title using params in the following
     * precendence
     * 1. titleKey parameter
     * 2. $state.$current.data.pageTitle (current state page title)
     * 3. 'global.title'
     */
    updateTitle(titleKey?: string) {
        if (
            !titleKey &&
            this.$state.current.data &&
            this.$state.current.data.pageTitle
        ) {
            titleKey = this.$state.current.data.pageTitle;
        }
        this.translateService
            .get(titleKey || 'global.title')
            .subscribe((title) => {
                window.document.title = title;
            });
    }

    changeLanguage(languageKey: string) {
        this.languageService.changeLanguage(languageKey);
        this.languageChange.emit(languageKey);
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/language/language.helper.ts